import { useAuth } from "../contexts/AuthContext";

export const useAuthState = () => {
  const auth = useAuth();

  return {
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
    isFetchingToken: auth.isFetchingToken,
    error: auth.error,
    user: auth.user,
    isInitialized: auth.isInitialized,
  };
};

export const useAuthActions = () => {
  const auth = useAuth();

  return {
    login: auth.login,
    logout: auth.logout,
    fetchNewToken: auth.fetchNewToken,
    clearError: auth.clearError,
  };
};

export const useToken = () => {
  const auth = useAuth();

  return {
    token: auth.token,
    getToken: auth.getToken,
    isAuthenticated: auth.isAuthenticated,
  };
};

export const useProtectedRoute = (redirectPath = "/login") => {
  const { isAuthenticated, isLoading, isInitialized } = useAuthState();

  return {
    isAuthenticated,
    isLoading: isLoading || !isInitialized,
    redirectPath,
    shouldRedirect: isInitialized && !isLoading && !isAuthenticated,
  };
};

export const useManualLogin = () => {
  const { login, isLoading, error, clearError } = useAuth();

  const handleLogin = async (username, password) => {
    clearError();
    return await login(username, password);
  };

  return {
    handleLogin,
    isLoading,
    error,
    clearError,
  };
};

export const useTokenFetch = () => {
  const { fetchNewToken, isFetchingToken } = useAuth();

  const handleFetch = async () => {
    try {
      const result = await fetchNewToken();
      return result;
    } catch (error) {
      throw error;
    }
  };

  return {
    fetchNewToken: handleFetch,
    isFetchingToken,
  };
};

export default {
  useAuthState,
  useAuthActions,
  useToken,
  useProtectedRoute,
  useManualLogin,
  useTokenFetch,
};
